import { render, staticRenderFns } from "./UserTransfer.vue?vue&type=template&id=411aea62&scoped=true&"
import script from "./UserTransfer.vue?vue&type=script&lang=js&"
export * from "./UserTransfer.vue?vue&type=script&lang=js&"
import style0 from "./UserTransfer.vue?vue&type=style&index=0&id=411aea62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "411aea62",
  null
  
)

export default component.exports